import React from "react";

export type TabKey = "overview" | "messages";

interface Props {
  active: TabKey;
  onChange: (tab: TabKey) => void;
  unread?: number;
}

const BookingTabs: React.FC<Props> = ({ active, onChange, unread = 0 }) => {
  const tabs: { key: TabKey; label: string }[] = [
    { key: "overview", label: "Overview" },
    { key: "messages", label: "Messages" },
  ];
  return (
    <div role="tablist" aria-label="Booking sections" className="flex gap-6 overflow-x-auto border-b border-neutral-200 dark:border-neutral-800">
      {tabs.map((t) => (
        <button
          key={t.key}
          role="tab"
          type="button"
          aria-selected={active === t.key}
          onClick={() => onChange(t.key)}
          className={`-mb-px whitespace-nowrap border-b-2 px-0.5 pb-3 pt-2 text-[15px] font-medium transition-colors ${
            active === t.key
              ? "border-[#C2410C] text-neutral-900 dark:text-white"
              : "border-transparent text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white"
          }`}
        >
          {t.label}
          {t.key === "messages" && unread > 0 && (
            <span className="ml-2 rounded-full bg-[#C2410C] px-2 py-0.5 text-xs font-semibold text-white">{unread}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default BookingTabs;
